import { render, staticRenderFns } from "./OnboardingUpdateInstProfile.vue?vue&type=template&id=3d710abf&scoped=true&"
import script from "./OnboardingUpdateInstProfile.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUpdateInstProfile.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingUpdateInstProfile.vue?vue&type=style&index=0&id=3d710abf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d710abf",
  null
  
)

export default component.exports